export const useWikiModalFull = () => {
  // Move to useState to prevent SSR worker memory accumulation
  const activeWikiModalFull = useState('activeWikiModalFull', () => false)
  const dataWikiModalFull = useState('dataWikiModalFull', () => ({} as any))

  const set = (type: any, id: any) => {    
    dataWikiModalFull.value = { type, id }
  }

  const close = () => {   
    activeWikiModalFull.value = false
    dataWikiModalFull.value = {}
  } 

  const open = (type: any, id: any) => {    
    activeWikiModalFull.value = true
    dataWikiModalFull.value = { type, id }
  }

  return { active: activeWikiModalFull, data: dataWikiModalFull, set, open, close };
}

